import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { clean, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => ({
      ID: item.id + '',
      code: item.code,
      name: item.name,
      type: item.type,
      status: item.status ? 'ACTIVATED' : 'DEACTIVATED',
    })),
  }
}

const getAllBankCodes = (data: any, paginationInfo: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.bankCodeGetAll),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      inputFilter: {
        ...clean(data),
        ...(data?.status && { status: data?.status === 'ACTIVATED' ? true : false }),
      },
      configParams: paginationInfo,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllBankCodes }
